import { useState } from 'react'
import { Checkbox } from 'antd'
import { adminJobRequestQuery_jobRequest_parts_linesWithWorkOrderMapping as JobRequestLineType } from '@OpsQuality/JobRequestDetails/__generated__/adminJobRequestQuery'
import { HybridProcessesType } from '@OpsQuality/components/Inspection/components/types'

import Box from '~/core/Box'

import UploadUI from './UploadUI'
import styles from './styles.css'
import ShowFirstItem from './ShowFirstItem'
import ShowMultipleItems from './ShowMultipleItems'

const HybridProcesses = (props: HybridProcessesType) => {
    const {
        jobRequestId,
        attachmentTypeDetails,
        attachmentSource,
        isJobCompleted,
    } = props

    const { jobRequestLinesByProcessTypeOrMaterialType } = attachmentTypeDetails

    const [, ...jobRequestLinesTailed] =
        jobRequestLinesByProcessTypeOrMaterialType

    const headJobRequestLines = jobRequestLinesByProcessTypeOrMaterialType[0]

    const [selectedJobRequestLine, setJobRequestLine] = useState<
        JobRequestLineType[]
    >([])

    const onCheckBoxChange = (checkedValues: any) =>
        setJobRequestLine(checkedValues)

    const [checkboxesLocked, setCheckboxesLocked] = useState(false)

    return (
        <Box
            direction="col"
            height="100%"
            className={styles.inspectionFragmentBody}
            maxWidth="400px"
            padding="16px"
        >
            <Box direction="col">
                Please attach the required documents for the following part.
                <span style={{ fontWeight: 500 }}>
                    <ShowFirstItem firstJobRequestLine={headJobRequestLines} />
                </span>
            </Box>
            {jobRequestLinesTailed.length > 0 && (
                <Box direction="col">
                    Parts selected below will also be associated with these
                    uploaded documents.
                    <Checkbox.Group
                        onChange={onCheckBoxChange}
                        style={{ width: '100%', fontWeight: 500 }}
                    >
                        <ShowMultipleItems
                            checkboxesLocked={checkboxesLocked}
                            allButFirstItems={jobRequestLinesTailed}
                        />
                    </Checkbox.Group>
                </Box>
            )}
            <UploadUI
                selectedJobRequestLines={[
                    headJobRequestLines,
                    ...selectedJobRequestLine,
                ]}
                attachmentTypeDetails={attachmentTypeDetails}
                jobRequestId={jobRequestId}
                multiple
                uploadTitle={`Upload document(s)`}
                attachmentSource={attachmentSource}
                isJobCompleted={isJobCompleted}
                setCheckboxesLocked={setCheckboxesLocked}
            />
        </Box>
    )
}

export default HybridProcesses
